import { IAppState } from '@state/types';
import { ITemplate } from './types';

export const getTemplates = (state: IAppState): any | undefined => state.templates.templates;

export const getEveryTemplates = (state: IAppState): ITemplate[] | undefined => state.templates.everyTemplates;

export const getTemplate = (state: IAppState): any | undefined => state.templates.template;

export const getTemplateResponse = (state: IAppState): any | undefined => state.templates.response;

export const getTemplateSearch = (state: IAppState): any | undefined => state.templates.searches;

export const getTemplateCounter = (state: IAppState): any | undefined => state.templates.counter;